import { render, staticRenderFns } from "./crtList.vue?vue&type=template&id=1a1f1f7c&"
import script from "./crtList.vue?vue&type=script&lang=js&"
export * from "./crtList.vue?vue&type=script&lang=js&"
import style0 from "./crtList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports